import { FC, ReactNode } from 'react';

type PartnerSocietyTableWrapperProps = {
  title: string;
  children: ReactNode;
};

const PartnerSocietyTableWrapper: FC<PartnerSocietyTableWrapperProps> = ({
  title,
  children,
}) => (
  <div className="card-inner px-0">
    <h6 className="overline-title-alt mb-2">{title}</h6>
    {children}
  </div>
);

export default PartnerSocietyTableWrapper;
